import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { api, type SessionResponse } from './api.js';

interface AuthState {
  user: SessionResponse['user'] | null;
  organizationId: string | null;
  role: string | null;
  /** Null until the first session check resolves, so routes can wait. */
  initialised: boolean;
}

const initialState: AuthState = {
  user: null,
  organizationId: null,
  role: null,
  initialised: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signedOut: (state) => {
      state.user = null;
      state.organizationId = null;
      state.role = null;
      state.initialised = true;
    },
    sessionLoaded: (state, action: PayloadAction<SessionResponse>) => {
      state.user = action.payload.user;
      state.organizationId = action.payload.organization?.id ?? null;
      state.role = action.payload.role;
      state.initialised = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(api.endpoints.getSession.matchFulfilled, (state, { payload }) => {
        state.user = payload.user;
        state.organizationId = payload.organization?.id ?? null;
        state.role = payload.role;
        state.initialised = true;
      })
      .addMatcher(api.endpoints.getSession.matchRejected, (state) => {
        state.user = null;
        state.initialised = true;
      })
      .addMatcher(api.endpoints.login.matchFulfilled, (state, { payload }) => {
        state.user = payload.user;
        state.organizationId = payload.organization?.id ?? null;
        state.role = payload.role;
        state.initialised = true;
      });
  }
});

export const { signedOut, sessionLoaded } = authSlice.actions;
export const authReducer = authSlice.reducer;
